// Version information injected at build time by Vite
declare const __APP_VERSION__: string
declare const __BUILD_TIME__: string

export const APP_VERSION = __APP_VERSION__
export const BUILD_TIME = __BUILD_TIME__

export interface AppVersionInfo {
  version: string
  buildTime: string
  userAgent: string
  url: string
}

export function getVersionInfo(): AppVersionInfo {
  return {
    version: APP_VERSION,
    buildTime: BUILD_TIME,
    userAgent: navigator.userAgent,
    url: window.location.href,
  }
}

export function logVersionInfo(): void {
  if (!import.meta.env.DEV) return

  const info = getVersionInfo()
  const style = 'color: #10b981; font-weight: bold; font-size: 14px;'
  const style2 = 'color: #6b7280; font-size: 12px;'

  console.log(`%c🚀 shadcn Mockups v${info.version}`, style)
  console.log(`%c📦 Build: ${new Date(info.buildTime).toLocaleString()}`, style2)
  console.log(`%c🌐 URL: ${info.url}`, style2)
  console.log('Version info:', info)
}
